type ErrorPageProps = {
  error: unknown;
  visible: boolean;
};

export default function ErrorPage({ error, visible }: ErrorPageProps) {
  return (
    <div
      className="md:px-2"
      style={{
        visibility: visible ? "visible" : "hidden",
        height: visible ? "auto" : 0,
        position: visible ? "static" : "absolute",
        top: visible ? "auto" : 0,
      }}
    >
      <h2 className="text-md lg:text-xl font-semibold">
        There was an issue with your application
      </h2>
      <pre>{JSON.stringify(error)}</pre>
    </div>
  );
}
